import { IController } from 'angular';
import { IModalService } from '../../../_common/modal/services/modalService';
import { ICacheService } from '../../../_common/cache/services/cache.service';
interface IZoneModalController extends IController {
  modalsStopWorking(): void;
  modalsStartWorking(): void;
  approveZone(): void;
  showDialogVariants(): void;
}
export default class ZoneModalController implements IZoneModalController {
  private dialogHandoff = false;

  /* @ngInject */
  constructor(private readonly modalService: IModalService, private readonly zoneService: any, private readonly advCacheService: ICacheService) {}
  $onInit() {
    this.modalsStopWorking();
    this.advCacheService.resetLastModified();
    this.modalService.getModal('zoneModalQuestion').then(modal => {
      const originalCallbackClose = modal.modalScope.callbackClose;
      modal.modalScope.callbackClose = (...args) => {
        originalCallbackClose?.apply(modal.modalScope, args);
        if (!this.dialogHandoff) {
          this.modalsStartWorking();
        }
      };
      modal.modalScope.open(true, undefined, true);
    });
  }
  modalsStopWorking() {
    this.modalService.stopWorking();
  }
  modalsStartWorking() {
    this.modalService.startWorking();
  }
  approveZone() {
    this.zoneService.approveZone();
  }
  showDialogVariants() {
    this.dialogHandoff = true;
    this.zoneService.zoneDialogOpen(undefined, () => this.modalsStartWorking());
  }
}
ZoneModalController.$inject = ["modalService", "zoneService", "advCacheService"];
angular.module('zone').controller('ZoneModalCtrl', ZoneModalController);